import React, { Component } from "react";
import { Container, Row, Col, Image, Form, Button, Modal, Nav, Spinner, ButtonGroup, Tab, Dropdown } from "react-bootstrap";
import Loader from "./LoaderModal";
import Side from "./Sidebar";
import Top from "./Topbar";
import C from '../lib/Config';
import {Pagination, PaginationOpts, TableHeader, TableBody, Filter, useDatatableLifecycle, shouldTableUpdate} from 'react-bs-datatable';
const CustomTable = React.memo(props => {
    const {
          data, rowsPerPageOption, tableHeaders, onChangeFilter, onPageNavigate, classes, onRowsPerPageChange, onSortChange,
          tableClass, labels, filterable, filterText, rowsPerPage, currentPage, sortedProp, maxPage, Components
    } = useDatatableLifecycle(props);
  
    return (
      <div>
        <Components.Row className="controlRow__root">
          <Components.Col xs="12">
            <Filter
              classes={classes}
              tableHeaders={tableHeaders}
              placeholder='Search by Name'
              onChangeFilter={onChangeFilter}
              filterText={filterText}
              filterable={filterable}
            />
          </Components.Col>
        </Components.Row>
        <Components.Row>
          <Components.Col xs="12">
            <Components.Table className={tableClass}>
              <TableHeader
                classes={classes}
                tableHeaders={tableHeaders}
                sortedProp={sortedProp}
                onSortChange={onSortChange}
                components={{
                  TableHead: Components.TableHead,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
              <TableBody
                classes={classes}
                tableHeaders={tableHeaders}
                labels={labels}
                data={data}
                components={{
                  TableBody: Components.TableBody,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
            </Components.Table>
          </Components.Col>
        </Components.Row>
        <Components.Row className="controlRow__root bottom">
          <Components.Col xs={12} md={12} className="text-right">
            <Pagination
              classes={classes}
              data={data}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              onPageNavigate={onPageNavigate}
              labels={labels}
              maxPage={maxPage}
              components={{ Button: Components.Button, ButtonGroup: Components.ButtonGroup }}
            />
          </Components.Col>
        </Components.Row>
      </div>
    );
}, shouldTableUpdate);
export default class Pending extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pendingUsers: [],
            loaderModal: false
        }
        this.getPendingReg = this.getPendingReg.bind(this)
    }
    componentDidMount() {
        this.setState({ loaderModal: true })
        setTimeout(() => {
            this.getPendingReg();
            this.setState({ loaderModal: false })
        }, 3000)
    }

    approveOrReject(userDetail, appOrRejStatus) {
        let loggedInuser = localStorage.getItem('userId');
        let data = {
            userId: userDetail.userId,
            approveRejectStatus: appOrRejStatus,
            approveByIdDto: {
                userId: loggedInuser
            }
        }
        fetch(C.getUrl() + '/user/approveRejectUser', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                alert(error);
            } else {
                let msg = resObj.message;
                alert(msg);
                this.getPendingReg();
            }
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }

    getPendingReg() {
        return fetch(C.getUrl() + '/user/getRegistrationUserList')
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let error = resObj.subErrors;
                if (error !== 'undefined' && error !== null && error !== "") {
                    alert(error);
                } else {
                    let obj = resObj.message;
                if (obj === 'No record found.') {
                  
                } else {
                    this.setState({ data: JSON.parse(resObj.message)})
                    console.log(obj);
                    let tempData = JSON.parse(resObj.message);
                    let pendingUsers = [];
                    tempData.forEach(obj => {
                        let fileData = obj.profilePictureData;
                        let tempprofiledate;
                        if(obj.profilePictureData !== undefined && obj.profilePictureData !== null && obj.profilePictureData !== ''){
                            tempprofiledate = <Image src={fileData} className="rounded-circle w-32 mr-2" />;
                        }else{
                            tempprofiledate = <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />;
                        }
                      let data = {
                            id : tempprofiledate,
                            name : obj.firstName +' '+ obj.lastName,
                            degree : obj.profDegreeDto.profDegreeName,
                            role : obj.userRoleDto.roleName,
                            date : obj.creationDate,
                            buttonApprove: <span><Button type="button" className="btn btn-success letterS fs-13 mr-2" onClick={() => this.approveOrReject(obj, 'A')}>Approve</Button> <Button type="button" className="btn btn-danger letterS fs-13" onClick={() => this.approveOrReject(obj, 'R')}>Reject</Button></span>
                        }
                        pendingUsers.push(data);
                    });
                  console.log(pendingUsers);
                  this.setState({ pendingUsers: pendingUsers });
                  console.log(this.state.pendingUsers);
                }
            }
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }
    render() {
        const header = [{title: '#', prop: 'id'},{title: 'Full Name', prop: 'name', sortable: true, filterable: true},{title: 'Qualification', prop: 'degree', sortable: true},{title: 'Role', prop: 'role', sortable: true},{title: 'Date of Registeration', prop: 'date'},{title: 'Status', prop: 'buttonApprove'},];
        const customLabels = {show: 'Display', entries: 'rows', noResults: 'No records found'};
        const classes = {table: 'table-striped table-striped table-hover text-nowrap dataTable mt-4', thead: 'thead-light'};
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                <div className="card-header flex-wrap">
                                                    <h3 className="fs-18 mb-0 header_title text-black">Pending Users</h3>
                                                </div>
                                                <div className="card-body p-3">
                                                    <div className="row">
                                                        <Col lg='12'>
                                                            <CustomTable
                                                                id="datatableProtocolList"
                                                                tableHeaders={header}
                                                                tableBody={this.state.pendingUsers} 
                                                                rowsPerPage={8}
                                                                //rowsPerPageOption={[5, 10, 15, 20]}
                                                                initialSort={{ prop: 'id', isAscending: true }}
                                                                labels={customLabels}
                                                                classes={classes}
                                                            />
                                                        </Col>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <Loader show={this.state.loaderModal} />
                    </div>
                </div>
            </div>
        )
    }
}